<script lang="ts" setup>
import {Component, computed, ref} from "vue";
import {IComponentInputEmits, IComponentSearchProps} from "@/types/main";
import {vMaska} from 'maska'

const props = withDefaults(defineProps<IComponentSearchProps>(), {
  modelValue: "",
  placeholder: "Placeholder",
  type: "text",
  width: "329px",
  height: "44px",
});

const isFocused = ref(false);

const customStyle = computed(() => {
  return {
    width: props.width,
    height: props.height,
    ...props.additionalStyle,
  };
});

const emit = defineEmits<IComponentInputEmits>();

const appendIconClick = () => {
  emit("appendIconClick")
}

const onInput = (e: Event) => {
  emit(
      "update:modelValue",
      (e.target as HTMLInputElement | HTMLTextAreaElement).value
  );
}

const onFocus = () => {
  isFocused.value = true;
  emit("focus");
}

const onBlur = () => {
  isFocused.value = false;
  emit("blur");
}
</script>

<template>
  <label>
    <div class="c-cu-search" :style="customStyle">
      <div class="icon">
        <component :is="icon" :size="20"/>
      </div>
      <div class="input">
        <input
            :value="modelValue"
            id="custom_search"
            v-maska
            :data-maska="mask"
            :type="type"
            :placeholder="placeholder"
            @input="onInput"
            @focus="onFocus"
            @blur="onBlur"
        />

        <div v-if="appendIcon" class="append-icon" @click="appendIconClick">
          <component :is="appendIcon" :size="20"/>
        </div>
      </div>
    </div>
  </label>
</template>

<style scoped lang="scss">
.c-cu-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  background: var(--color-bg-secondary);
  border: 1px solid var(--color-border);
  border-radius: 14px;
  padding-left: 12px;
  padding-right: 12px;

  &:focus-within,
  &:hover {
    border-color: var(--color-secondary-label);
  }

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    color: var(--color-secondary-label);
    background: transparent;
  }

  .input {
    width: 100%;

    input {
      background: var(--color-bg-secondary);
      border: none;
      font-size: 16px;
      line-height: 24px;
      height: 24px;
      width: 100%;
      color: var(--color-label);

      &:focus {
        outline: none;
      }
    }
  }
}
</style>